import { render, staticRenderFns } from "./CompanionWorkshopRegisterUnregisterModal.vue?vue&type=template&id=32b17373&scoped=true&lang=pug&"
import script from "./CompanionWorkshopRegisterUnregisterModal.vue?vue&type=script&lang=js&"
export * from "./CompanionWorkshopRegisterUnregisterModal.vue?vue&type=script&lang=js&"
import style0 from "./CompanionWorkshopRegisterUnregisterModal.vue?vue&type=style&index=0&id=32b17373&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b17373",
  null
  
)

export default component.exports